/**
 * The minimap's words (P1.9-T52, R-0055; the design's `minimap` card in `PvpSurfaces.jsx`, a visual reference), every
 * one a draft for the author: the frame's accessible name, the two zoom controls' names (the design's "Zoom in" and
 * "Zoom out"), the field's accessible name and the legend's entries (you, party, and each kind of other mark, listed
 * only while one is in view), and the line under the field that says where the player is (P1.9-T197: `placeName`, the
 * name before its colon, and `placeTile`, the two numbers, which the line sets side by side so a long name is cut short
 * and the numbers never are). The Map button is named by `worldMap.button` (P2.12-T22).
 */
export const MINIMAP = {
  frame: "Minimap",
  zoomIn: "Zoom in",
  zoomOut: "Zoom out",
  field: "The area within your vision",
  you: "You",
  party: "Party",
  players: "Players",
  flagged: "PvP flagged",
  npcs: "People",
  passive: "Calm creatures",
  quest: "Quests",
  questTarget: "Quest targets",
  neutral: "Wary creatures",
  hostile: "Hostile creatures",
  elite: "Elites and bosses",
  placeName: "{name}:",
  placeTile: "{x}, {y}",
  pipLine: "{name}, {where}",
  pipQuest: "Quest: {title}",
  compassList: "Compass: {items}",
} as const;
